import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../styles";

const states = {
  activo: "green",
  suspendido: "yellow",
  inactivo: "gray",
  borrado: "red",
};

export default function GenderTable({ data, currentPage, totalPages, onPreviousPage, onNextPage }) {
  const classes = useStyles();

  if (data == null || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root} >
            <TableCell size='small' >NOMBRE</TableCell>
            <TableCell size='small' style={{ textAlign: "center" }} >ÚLTIMA MODIFICACIÓN</TableCell>
            <TableCell size='small' padding='none' style={{ textAlign: "center" }} >ESTATUS</TableCell>
            {/*{keys.map(key => (
            <TableCell key={key}>{key}</TableCell>
          ))}*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, name, genderStatus, lastUpdateDate }) => (
            <TableRow key={id}>
              <TableCell size='small' className={classes.tableTextStyle} >{name}</TableCell>
              <TableCell size='small' className={classes.tableCenterTextStyle} >{lastUpdateDate}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableCenterTextStyle} >
                <Chip label={genderStatus} classes={{ root: classes[states[genderStatus.toLowerCase()]] }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className={classes.footerTable}>
        <div className={classes.footerTableSecondDiv}>
          <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
          <div className={currentPage <= 1 ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowBackIos className={currentPage <= 1 ?
              classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
              onClick={currentPage <= 1 ? null : onPreviousPage}
            />
          </div>
          <div className={classes.spaceBetweenButtons}></div>
          <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowForwardIos className={currentPage == totalPages ?
              classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
              onClick={currentPage == totalPages ? null : onNextPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
